import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    isChecked: boolean;
    width: number;
}

export class CheckColumn extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        isChecked: false,
        width: 180
    };

    constructor(props: IProperties)
    {
        super(props);
    }

    render()
    {
        const { isChecked, width } = this.props;
        const className: string[] = ["n-table_cell_check"];

        if (isChecked)
            className.push("n-table_cell_check--checked");

        return (
            <div
                className="n-table_cell"
                style={{
                    width: width
                }}>
                <div className={className.join(" ")}>
                    {
                        isChecked ? <i className="mdi mdi-check-circle"></i> : <i className="mdi mdi-checkbox-blank-circle-outline"></i>
                    }
                </div>
            </div>
        );
    }
}